<script setup>
const gsapTimeline = useGsapTimeline()
defineProps({
  text: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['timeline'])

const outlineElement = ref(null)
const boldCharactersElement = ref(null)

onMounted(() => {
  const boldCharactersElementChildren = boldCharactersElement.value.children

  const timeline = gsapTimeline()
    .set(outlineElement, { visibility: 'inherit' })
    .set(boldCharactersElementChildren, { visibility: 'inherit' })
    .from(outlineElement, { scale: 1.5, letterSpacing: '-120px', transformOrigin: 'bottom left', right: 260, duration: 0.24, ease: 'power2.inOut' })
    .from(boldCharactersElementChildren, { y: -550, duration: 0.08, stagger: { amount: 0.2 }, ease: 'power2.inOut' }, '<.040')
    .set(outlineElement, { opacity: 0 })
    .to(boldCharactersElement, { right: 720, duration: 0.24, ease: 'power3.in' }, '<')
    .set(outlineElement, { visibility: 'hidden' })
    .set(boldCharactersElementChildren, { visibility: 'hidden' })

  emit('timeline', timeline)
})
</script>

<template>
  <div ref="outlineElement" class="invisible absolute z-50 -top-3 right-[-260px] text-transparent text-[1220px] font-semibold text-stroke-5 text-stroke-white whitespace-nowrap" v-text="text" />
  <div ref="boldCharactersElement" class="absolute z-40 -top-3 right-[-260px] text-q-cr-red-primary text-[1220px] font-semibold flex whitespace-nowrap">
    <div v-for="char in text" :key="char" class="left-0 invisible">{{ char }}</div>
  </div>
</template>
